// extracted by mini-css-extract-plugin
export var textInput = "_fu-0";